export const errorCallback = () =>
  (document.querySelector(".articleFeed").style.display = "none");
